<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <core-table
          upsertMaxWidth="950"
          title="Points"
          :config="config"
          :hiddenFields="{'country_code':'IT'}">
        </core-table>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import config from './config_index.js'
// import {getList} from '@/api/base_entity.js'

export default {
  data () {
    return {
      config,
    }
  },
  async mounted() {
  },
  methods: {
  }
}
</script>
